import React, { useEffect, useState } from "react";
import {
  CustomPagination,
  GoBack,
  PageLoader,
  SearchBar,
} from "../../../Components/Components";
import { useDispatch } from "react-redux";
import {
  DeleteQuizAPI,
  EditQuizAPI,
  GetQuizParticipantsAPI,
  GetQuizzesAPI,
  PublishQuizAPI,
  ReorderQuestionAPI,
} from "../../Redux/quiz";
import { useNavigate, useParams } from "react-router-dom";
import { QuizStatusTypes } from "./Quizzes";
import { Dropdown, message, Table } from "antd";
import svg from "../../../Assets/svg";
import {
  formatIncomingDate,
  formatIncomingDateWithTime,
  utcToLocalDate,
  utcToLocalDateTime,
} from "../../../helpers/utils";
import ImportQuestionsModal from "./Modals/ImportQuestionsModal";
import AddQuestionFormModal from "../QuestionBank/Modals/AddQuestionFormModal";
import { ActionModal } from "../../../Components/Modal/Modal";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  KeyboardSensor,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
  sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import {
  restrictToParentElement,
  restrictToVerticalAxis,
} from "@dnd-kit/modifiers";
import { CSS } from "@dnd-kit/utilities";
import CreateQuizModal from "./Modals/CreateQuizModal";
import { GetNavbarCounts } from "../../Redux/challenges";
import ViewQuestionDetailsModal from "../QuestionBank/Modals/ViewQuestionDetailsModal";

const QuizDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(true);
  const [participantsLoading, setParticipantsLoading] = useState(true);
  const [quizDetails, setQuizDetails] = useState(null);

  const [page, setPage] = useState(1);
  const limit = 15;
  const [totalCount, setTotalCount] = useState();
  const [participants, setParticipants] = useState([]);
  const pageCount = Math.ceil(totalCount / limit);

  const [isDeleteQuizModalOpen, setIsDeleteQuizModalOpen] = useState(false);
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const [publishing, setPublishing] = useState(false);

  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");

  const { quizId } = useParams();

  const [activeTab, setActiveTab] = useState("quiz");

  const [questionFormSettings, setQuestionFormSettings] = useState({
    isModalOpen: false,
    questionId: null,
    quizId: null,
  });

  const [deleteQuestionSettings, setDeleteQuestionSettings] = useState({
    isModalOpen: false,
    questionId: null,
  });

  const [isQuizFormModalOpen, setIsQuizFormModalOpen] = useState(false);

  const [deleting, setDeleting] = useState(false);

  const [expandedQuestions, setExpandedQuestions] = useState([]);

  const [importQuestionsModalSettings, setImportQuestionsModalSettings] =
    useState({
      isModalOpen: false,
    });

  const [viewQuestionModalSettings, setViewQuestionModalSettings] = useState({
    visible: false,
    questionId: null,
  });

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const fetchQuizDetails = async () => {
    setFetching(true);
    const result = await dispatch(
      GetQuizzesAPI({
        id: quizId,
      })
    );
    if (result?.success) {
      // setTotalCount(result.data.total);
      setQuizDetails(result.data.data[0]);
    }
    setFetching(false);
  };

  useEffect(() => {
    fetchQuizDetails();
  }, []);

  const fetchParticipants = async () => {
    setParticipantsLoading(true);
    const result = await dispatch(
      GetQuizParticipantsAPI({
        page: page,
        limit: limit,
        quizId: quizId,
        search: debouncedSearchValue,
      })
    );
    if (result?.success) {
      // setTotalCount(result.data.total);
      // setQuizDetails(result.data.data[0]);
      setParticipants(result.data.results);
      setTotalCount(result.data.totalCount);
    }
    setParticipantsLoading(false);
  };

  useEffect(() => {
    fetchParticipants();
  }, [page, debouncedSearchValue]);

  useEffect(() => {
    if (searchValue === "") {
      setDebouncedSearchValue("");
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchValue]);

  const quizItems = [
    ...(quizDetails?.status !== QuizStatusTypes.Published
      ? [
          {
            label: (
              <div
                href="#"
                className="text-decoration-none fs-14"
                // onClick={() => handleClick("edit")}
                onClick={() => setIsQuizFormModalOpen(true)}
              >
                {svg?.editIcon}
                Edit
              </div>
            ),
            key: "0",
          },
        ]
      : []),
    {
      label: (
        <div
          href="#"
          className="text-decoration-none fs-14"
          // onClick={() => handleClick("delete")}
          onClick={() => setIsDeleteQuizModalOpen(true)}
        >
          {svg?.deleteSmall}
          Delete
        </div>
      ),
      key: "2",
    },
  ];

  const getQuestionDropdownItems = (questionId) => [
    {
      label: (
        <div className="text-decoration-none fs-14">
          {svg?.editIcon}
          Edit
        </div>
      ),
      key: "edit",
      data: { action: "edit", questionId },
    },
    {
      label: (
        <div className="text-decoration-none fs-14">
          {svg?.deleteSmall}
          Delete
        </div>
      ),
      key: "delete",
      data: { action: "delete", questionId },
    },
  ];

  const handleQuestionDropdownAction = ({ action, questionId }) => {
    if (action === "edit") {
      // Do something with questionId
      setQuestionFormSettings({ isModalOpen: true, questionId });
    } else if (action === "delete") {
      if (
        quizDetails?.status === QuizStatusTypes.Scheduled &&
        quizDetails?.questions?.length === 1
      ) {
        message.error("Cannot delete the last question in scheduled quiz");
        return;
      }
      setDeleteQuestionSettings({ isModalOpen: true, questionId });
    }
  };

  const deleteChallengeHandler = async () => {
    const payload = {
      quiz_id: quizId,
      type: "remove",
      questions: [deleteQuestionSettings.questionId],
    };
    setDeleting(true);
    await dispatch(
      EditQuizAPI(
        payload,
        () => {
          setDeleteQuestionSettings({ isModalOpen: false, questionId: null });
          setDeleting(false);
          fetchQuizDetails();
        },
        () => {
          setDeleting(false);
        }
      )
    );
  };

  const publishQuizHandler = () => {
    const payload = {
      id: quizId,
    };
    setPublishing(true);
    dispatch(
      PublishQuizAPI(
        payload,
        () => {
          setIsPublishModalOpen(false);
          setPublishing(false);
          fetchQuizDetails();
        },
        () => {
          setPublishing(false);
        }
      )
    );
  };

  const deleteQuizHandler = async () => {
    setDeleting(true);
    await dispatch(
      DeleteQuizAPI(
        quizId,
        () => {
          setIsDeleteQuizModalOpen(false);
          setDeleting(false);
          navigate("/admin/quizzes");
        },
        () => {
          setDeleting(false);
        }
      )
    );
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = quizDetails.questions.findIndex(
      (q) => q.question._id === active.id
    );
    const newIndex = quizDetails.questions.findIndex(
      (q) => q.question._id === over.id
    );

    const reordered = arrayMove(quizDetails.questions, oldIndex, newIndex);

    setQuizDetails((prev) => ({
      ...prev,
      questions: reordered,
    }));

    const payload = {
      quiz_id: quizId,
      oldPosition: oldIndex,
      newPosition: newIndex,
    };

    dispatch(ReorderQuestionAPI(payload));
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div className="">
            {record?.user?.name ? record?.user?.name : "-"}
          </div>
        );
      },
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
      render: (_, record) => {
        return (
          <div className="">
            {record?.user?.phone_number ? record?.user?.phone_number : "-"}
          </div>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, record) => {
        return (
          <div className="">
            {record?.user?.email ? record?.user?.email : "-"}
          </div>
        );
      },
    },
    {
      title: "Questions",
      dataIndex: "questions",
      key: "questions",
      render: (_, record) => {
        return (
          <div className="">
            {record?.totalQuestions > -1 ? record?.totalQuestions : "-"}
          </div>
        );
      },
    },
    {
      title: "Correct",
      dataIndex: "correct",
      key: "correct",
      render: (_, record) => {
        return (
          <div className="">
            {record?.correctCount > -1 ? record?.correctCount : "-"}
          </div>
        );
      },
    },
    {
      title: "Incorrect",
      dataIndex: "incorrect",
      key: "incorrect",
      render: (_, record) => {
        return (
          <div className="">
            {record?.incorrectCount > -1 ? record?.incorrectCount : "-"}
          </div>
        );
      },
    },
    {
      title: "Skipped",
      dataIndex: "skipped",
      key: "skipped",
      render: (_, record) => {
        return (
          <div className="">
            {record?.skippedCount > -1 ? record?.skippedCount : "-"}
          </div>
        );
      },
    },
    {
      title: "Submit Date",
      dataIndex: "skipped",
      key: "skipped",
      render: (_, record) => {
        return (
          <div className="">
            {record?.submitted_at
              ? formatIncomingDateWithTime(record?.submitted_at)
              : "-"}
          </div>
        );
      },
    },
  ];

  const SortableQuestionRow = ({
    index,
    question,
    isExpanded,
    onToggleExpand,
    onDropdownAction,
    getDropdownItems,
  }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: question._id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <div
        className={`d-flex align-items-center gap-2 mb-2 ${
          isDragging ? "dragging" : ""
        }`}
        ref={setNodeRef}
        style={style}
      >
        {quizDetails?.status !== QuizStatusTypes.Published && (
          <div
            className={`${isDragging ? "cursor-grabbing" : "cursor-grab"}`} // applies grab/grabbing style
            {...attributes}
            {...listeners}
          >
            {svg?.dragHandle}
          </div>
        )}
        <div className="d-flex flex-column w-100 questionItemWrapper">
          <div
            className={`d-flex align-items-center w-100 ${
              isExpanded ? "question-list-header border-bottom" : ""
            }`}
          >
            <div className="question-list-title fs-6 fw-bold ff">
              {`${index + 1}. ${question?.question}`}
            </div>
            <div className="ms-auto d-flex gap-2">
              <div
                className={`${
                  question?.ans_type === "text" ? "text-green" : "text-orange"
                }  fs-6 fw-bold ff`}
              >
                {question?.ans_type === "text"
                  ? "Text Area"
                  : "Multiple Choice"}
              </div>
              <div
                className="cursor-pointer"
                style={{
                  visibility:
                    question?.ans_type === "text" ? "hidden" : "visible",
                }}
                onClick={onToggleExpand}
              >
                {isExpanded ? svg.collapseIcon : svg.expandIcon}
              </div>

              {quizDetails?.status !== QuizStatusTypes.Published && (
                <Dropdown
                  menu={{
                    items: getDropdownItems(question._id),
                    onClick: ({ key }) => {
                      const foundItem = getDropdownItems(question._id).find(
                        (i) => i.key === key
                      );
                      if (foundItem) onDropdownAction(foundItem.data);
                    },
                  }}
                  trigger={["click"]}
                  overlayClassName="moreActionDropdown"
                >
                  <a onClick={(e) => e.preventDefault()}>{svg?.dropDownIcon}</a>
                </Dropdown>
              )}
            </div>
          </div>
          {isExpanded && question?.options?.length > 0 && (
            <>
              <div className="row">
                {question?.options?.map((opt) => (
                  <div className="col-3" key={opt._id}>
                    <div className="answerOption d-flex justify-content-between align-items-center">
                      <span className="fs-6">{opt?.text || "-"}</span>
                      {opt.is_correct && (
                        <span className="svg-22 d-inline-block me-3 lh-0">
                          {svg?.correctOption}
                        </span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div>
                <label className="ff fs-6 fw-bold">Reflection:</label>{" "}
                <span className="ff fs-6">{question.reflection || "-"}</span>
              </div>
              <div>
                <label className="ff fs-6 fw-bold">Reference:</label>{" "}
                <span className="ff fs-6">{question.ay_reflection || "-"}</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="sidenav_content">
        {fetching ? (
          <PageLoader />
        ) : (
          <>
            <div className="container-fluid px-4 py-4 h-100">
              <div className="d-flex flex-column h-100">
                <GoBack />
                <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-2">
                  <h2 className="mb-0 fw-bold ff title-color fs-42">
                    {quizDetails?.title ? quizDetails.title : "-"}
                  </h2>
                  <div className="d-flex gap-3 justify-content-end align-items-center ms-auto">
                    <>
                      {quizDetails?.status && (
                        <div
                          className={`fs-5 ff fw-bold ${
                            quizDetails?.status === QuizStatusTypes.Draft
                              ? "text-grey"
                              : quizDetails?.status ===
                                QuizStatusTypes.Scheduled
                              ? "text-orange"
                              : "text-green"
                          }`}
                        >
                          {quizDetails?.status === QuizStatusTypes.Draft
                            ? "Draft"
                            : quizDetails?.status === QuizStatusTypes.Scheduled
                            ? "Scheduled"
                            : "Published"}
                        </div>
                      )}

                      {quizDetails?.status === QuizStatusTypes.Draft && (
                        <button
                          className={`btn btn-primary btn-lg ku-btn px-4 ff ${
                            quizDetails?.questions?.length > 0 ? "" : "disabled"
                          }`}
                          onClick={() => setIsPublishModalOpen(true)}
                        >
                          Publish
                        </button>
                      )}

                      <div>
                        <Dropdown
                          menu={{ items: quizItems }}
                          trigger={["click"]}
                          overlayClassName="moreActionDropdown"
                        >
                          <a
                            onClick={(e) => e.preventDefault()}
                            className="svg-36"
                          >
                            {svg?.moreActionBtn}
                          </a>
                        </Dropdown>
                      </div>
                    </>
                  </div>
                </div>
                <div className="createdBy fs-6 mb-3">
                  <label className="mb-0 text-939598">Published On:</label>{" "}
                  <span className="fw-bold ff">
                    {quizDetails?.published_on
                      ? utcToLocalDate(quizDetails.published_on)
                      : "-"}
                  </span>
                </div>

                <div className="mb-3 d-flex flex-wrap align-items-center gap-3">
                  <div className="d-flex align-items-center gap-3">
                    <button
                      onClick={() => setActiveTab("quiz")}
                      className={`btn btn-lg btn-42 btn-outline-primary rounded-3 ${
                        activeTab === "quiz" ? "active" : ""
                      }`}
                    >
                      Quiz Details
                    </button>
                    <button
                      onClick={() => setActiveTab("participants")}
                      className={`btn btn-lg btn-42 btn-outline-primary rounded-3 ${
                        activeTab === "participants" ? "active" : ""
                      }`}
                    >
                      {`Participants ${
                        participants.length > 0
                          ? `(${participants.length})`
                          : ""
                      }`}
                      {/* {leaderboardTotalCount > 0 && `(${leaderboardTotalCount})`} */}
                    </button>
                  </div>
                  {activeTab === "quiz" && (
                    <div
                      className="ms-auto text-orange ff fw-semibold fs-5 cursor-pointer user-select-none"
                      onClick={() =>
                        setExpandedQuestions(
                          quizDetails?.questions
                            .filter((q) => q.question.ans_type !== "text")
                            .map((q) => q.question._id)
                        )
                      }
                    >
                      Expand All
                    </div>
                  )}
                  {activeTab === "participants" && (
                    <div className="ms-auto">
                      <SearchBar
                        value={searchValue}
                        setValue={setSearchValue}
                        searchHandler={(e) => setSearchValue(e.target.value)}
                        placeholder={"Search"}
                        inputClass={"border-25 ps-5 ms-auto search-42"}
                        clearData={() => {
                          setParticipantsLoading(true);
                          setSearchValue("");
                        }}
                      />
                    </div>
                  )}
                </div>

                {activeTab === "quiz" && (
                  <div className="card rounded-4 border-0">
                    <div className="card-body p-30 fs-5">
                      <div className="d-flex flex-column">
                        <div className="border-bottom mb-3">
                          {quizDetails?.description
                            ? quizDetails.description
                            : "-"}
                        </div>
                        <div className="d-flex mb-2">
                          <div className="ff fw-bold">
                            Questions{" "}
                            {quizDetails?.questions?.length > 0
                              ? `(${quizDetails?.questions?.length})`
                              : ""}
                          </div>
                          {quizDetails?.status !==
                            QuizStatusTypes.Published && (
                            <div className="ms-auto d-flex gap-3 fw-semibold ff">
                              <div
                                className="cursor-pointer text-green"
                                onClick={() =>
                                  setQuestionFormSettings({
                                    isModalOpen: true,
                                    quizId,
                                  })
                                }
                              >
                                + Add Questions
                              </div>
                              <div
                                className="cursor-pointer text-orange"
                                onClick={() => {
                                  setImportQuestionsModalSettings({
                                    isModalOpen: true,
                                  });
                                }}
                              >
                                Import Questions
                              </div>
                            </div>
                          )}
                        </div>

                        {quizDetails?.questions?.length === 0 ? (
                          <div className="empty-quiz-container">
                            <div className="d-flex flex-column align-items-center justify-content-center empty-quiz-body gap-2">
                              <div style={{ color: "#939598" }}>
                                No Questions Added Yet!
                              </div>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn rounded-pill px-3 py-2  text-white"
                                  style={{
                                    backgroundColor: "#46C064",
                                  }}
                                  onClick={() => {
                                    // setIsChooseBannerModalOpen(true);

                                    setQuestionFormSettings({
                                      isModalOpen: true,
                                      quizId,
                                    });
                                  }}
                                >
                                  + Add Question
                                </button>
                                <button
                                  className="btn rounded-pill px-3 py-2  text-white"
                                  style={{
                                    backgroundColor: "#E58344",
                                  }}
                                  onClick={() => {
                                    setImportQuestionsModalSettings({
                                      isModalOpen: true,
                                    });
                                  }}
                                >
                                  Import Questions
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : (
                          quizDetails?.questions?.length > 0 && (
                            <DndContext
                              sensors={sensors}
                              collisionDetection={closestCenter}
                              onDragEnd={handleDragEnd}
                              modifiers={[
                                restrictToParentElement,
                                restrictToVerticalAxis,
                              ]}
                            >
                              <SortableContext
                                items={quizDetails?.questions?.map(
                                  (q) => q.question._id
                                )}
                                strategy={verticalListSortingStrategy}
                              >
                                {quizDetails?.questions?.map((e, index) => (
                                  <SortableQuestionRow
                                    key={e.question._id}
                                    index={index}
                                    question={e.question}
                                    isExpanded={expandedQuestions.includes(
                                      e.question._id
                                    )}
                                    onToggleExpand={() => {
                                      const isExpanded =
                                        expandedQuestions.includes(
                                          e.question._id
                                        );
                                      setExpandedQuestions((prev) =>
                                        isExpanded
                                          ? prev.filter(
                                              (id) => id !== e.question._id
                                            )
                                          : [...prev, e.question._id]
                                      );
                                    }}
                                    onDropdownAction={
                                      handleQuestionDropdownAction
                                    }
                                    getDropdownItems={getQuestionDropdownItems}
                                  />
                                ))}
                              </SortableContext>
                            </DndContext>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === "participants" &&
                  (participantsLoading ? (
                    <PageLoader />
                  ) : participants.length === 0 ? (
                    <div className="card rounded-4 border-0">
                      <div className="card-body p-30 fs-5">
                        <div className="d-flex align-items-center justify-content-center">
                          {searchValue
                            ? "No participants match your search."
                            : quizDetails?.status === QuizStatusTypes.Published
                            ? "The challenge has been published, but there are no participants yet."
                            : "The participant list will be visible once the challenge is published."}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="flex-fill overflow-y-auto d-flex flex-column">
                        <div
                          className="table-wrapper"
                          style={{ flex: 1, overflow: "hidden" }}
                        >
                          <Table
                            dataSource={participants}
                            className="antTable custom-antd-table"
                            scroll={{ y: "100%", x: 1124 }}
                            pagination={false}
                            columns={columns}
                          />
                        </div>
                      </div>
                      <CustomPagination
                        className={`mt-3`}
                        pageId={page}
                        setPageId={setPage}
                        pageCount={pageCount}
                        countCalculation={totalCount ? totalCount : 0}
                        limit={limit}
                      />
                    </>
                  ))}
              </div>
            </div>

            {importQuestionsModalSettings.isModalOpen && (
              <ImportQuestionsModal
                isModalOpen={importQuestionsModalSettings.isModalOpen}
                onClose={(refetch = false) => {
                  if (refetch) {
                    fetchQuizDetails();
                  }
                  setImportQuestionsModalSettings({
                    isModalOpen: false,
                  });
                }}
                quizId={quizId}
                questionsToPrefill={
                  quizDetails?.questions?.length > 0
                    ? quizDetails?.questions?.map((q) => q.question._id)
                    : []
                }
              />
            )}
          </>
        )}
      </div>

      {questionFormSettings.isModalOpen && (
        <AddQuestionFormModal
          isModalOpen={questionFormSettings.isModalOpen}
          onClose={(refetch = false, preventClose = false) => {
            console.log("Prevent close: ", preventClose);
            if (refetch) {
              dispatch(GetNavbarCounts());
              fetchQuizDetails();
            }
            if (!preventClose) {
              setQuestionFormSettings({
                isModalOpen: false,
                questionId: null,
                quizId: null,
              });
            }
          }}
          questionsLength={
            quizDetails?.questions?.length
              ? quizDetails?.questions?.length + 1
              : 1
          }
          questionId={questionFormSettings.questionId}
          quizId={questionFormSettings.quizId}
          onDuplicate={(questionId) => {
            setViewQuestionModalSettings({ questionId, visible: true });
            setQuestionFormSettings({
              isModalOpen: false,
              questionId: null,
              quizId: null,
            });
          }}
        />
      )}

      {viewQuestionModalSettings.visible && (
        <ViewQuestionDetailsModal
          isModalOpen={viewQuestionModalSettings.visible}
          onClose={(refetch = false, addNew = false) => {
            setViewQuestionModalSettings({ visible: false, questionId: "" });
            if (refetch) {
              dispatch(GetNavbarCounts());
              fetchQuizDetails();
            }
            if (addNew) {
              setQuestionFormSettings({
                isModalOpen: true,
                quizId: quizId,
              });
            }
          }}
          questionId={viewQuestionModalSettings.questionId}
          quizId={quizId}
        />
      )}

      <ActionModal
        isOpen={deleteQuestionSettings.isModalOpen}
        title="Delete Question, Are You Sure?"
        description={
          "This action will permanently delete the question. Are you sure you want to proceed?"
        }
        buttonText="Yes, Delete"
        isLoading={deleting}
        actionHandler={deleteChallengeHandler}
        cancelHandler={() =>
          setDeleteQuestionSettings({ isModalOpen: false, questionId: null })
        }
      />

      {isQuizFormModalOpen && (
        <CreateQuizModal
          isModalOpen={isQuizFormModalOpen}
          quizId={quizId}
          onClose={(refetch = false) => {
            if (refetch) {
              fetchQuizDetails();
            }
            setIsQuizFormModalOpen(false);
          }}
        />
      )}

      <ActionModal
        isOpen={isDeleteQuizModalOpen}
        title="Delete Quiz, Are You Sure?"
        description={
          "This action will permanently delete the quiz and all related data. Are you sure you want to proceed?"
        }
        buttonText="Yes, Delete"
        isLoading={deleting}
        actionHandler={deleteQuizHandler}
        cancelHandler={() => setIsDeleteQuizModalOpen(false)}
      />

      <ActionModal
        isOpen={isPublishModalOpen}
        title="Publish Quiz, Are You Sure?"
        icon={svg?.publishIcon}
        description={
          "Once published, the quiz will be visible to users on the selected date and can be edited until that date. Are you sure you want to proceed?"
        }
        buttonText="Yes, Publish"
        buttonClass="btn btn-primary"
        isLoading={publishing}
        actionHandler={publishQuizHandler}
        cancelHandler={() => setIsPublishModalOpen(false)}
      />
    </>
  );
};

export default QuizDetails;
